<template>
    <div>
        <div clas>
            <NavBarComponent />
            <router-view />
            <FooterComponent />
        </div>
    </div>
</template>

<script>
import FooterComponent from '@/components/FooterComponent.vue';
import NavBarComponent from '@/components/NavBarComponent.vue';

export default{
    name: 'LayoutHome',
    components:{
        NavBarComponent,
        FooterComponent
    }
}
</script>